var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.184,
    y1: 0.139,
    x2: 0.822,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbe18a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#fcbb45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#f75274"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.458,
    stopColor: "#d53692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.677,
    stopColor: "#8f39ce"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.824,
    stopColor: "#5b4fe9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1464",
    "data-name": "Group 1464",
    transform: "translate(-1686 -918)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_34",
    "data-name": "Ellipse 34",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1686 918)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1463",
    "data-name": "Group 1463",
    transform: "translate(1684.68 916.705)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69261",
    "data-name": "Path 69261",
    d: "M23.339,11a1.373,1.373,0,1,0,1.373,1.373A1.372,1.372,0,0,0,23.339,11",
    transform: "translate(1.887 0.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69262",
    "data-name": "Path 69262",
    d: "M18.434,12.558A5.766,5.766,0,1,0,24.2,18.324a5.772,5.772,0,0,0-5.766-5.766m0,9.46a3.694,3.694,0,1,1,3.694-3.694,3.7,3.7,0,0,1-3.694,3.694",
    transform: "translate(0.689 0.678)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69263",
    "data-name": "Path 69263",
    d: "M23.7,30.71H14.353A7.04,7.04,0,0,1,7.32,23.677V14.328A7.04,7.04,0,0,1,14.353,7.3H23.7a7.041,7.041,0,0,1,7.034,7.033v9.349A7.041,7.041,0,0,1,23.7,30.71M14.353,9.5a4.835,4.835,0,0,0-4.83,4.83v9.349a4.836,4.836,0,0,0,4.83,4.83H23.7a4.837,4.837,0,0,0,4.832-4.83V14.328A4.836,4.836,0,0,0,23.7,9.5Z",
    transform: "translate(0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaLogo);
export default __webpack_public_path__ + "static/media/insta_logo.732f131344a4ca91512dd4786d4da4eb.svg";
export { ForwardRef as ReactComponent };